export const ALL_COMPANY_GET_FETCH_START = "ALL_COMPANY_GET_FETCH_START";
export const ALL_COMPANY_GET_FETCH_SUCCESS = "ALL_COMPANY_GET_FETCH_SUCCESS";
export const ALL_COMPANY_GET_FETCH_FAILURE = "ALL_COMPANY_GET_FETCH_FAILURE";


export const SUPERADMIN_SINGLE_ORGANIZATION_GET_START="SUPERADMIN_SINGLE_ORGANIZATION_GET_START";
export const SUPERADMIN_SINGLE_ORGANIZATION_GET_SUCCESS="SUPERADMIN_SINGLE_ORGANIZATION_GET_SUCCESS";
export const SUPERADMIN_SINGLE_ORGANIZATION_GET_FINISH="SUPERADMIN_SINGLE_ORGANIZATION_GET_FINISH";


export const SINGLE_ORGANIZATION_DELETE_START="SINGLE_ORGANIZATION_DELETE_START";
export const SINGLE_ORGANIZATION_DELETE_SUCCESS="SINGLE_ORGANIZATION_DELETE_SUCCESS";
export const SINGLE_ORGANIZATION_DELETE_FAILURE="SINGLE_ORGANIZATION_DELETE_FAILURE";

